export const MAX_FILE_SIZE_MB = 10;
export const ACCEPTED_IMAGE_TYPES = 'image/*';
